import axios from 'axios';
import Auth from './Auth';

import { getEndpoint } from 'utils/api';

export default class Api {
    static get = <T>(endpoint, abortController, options?: object, returnResponse?: boolean): Promise<T> => {
        return Api.authenticatedRequest<T>('get', endpoint, abortController, null, options, returnResponse);
    };

    static post = <T>(endpoint, postData, abortController, options?: object, returnResponse?: boolean): Promise<T> => {
        return Api.authenticatedRequest<T>('post', endpoint, abortController, postData, options, returnResponse);
    };

    static authenticatedRequest = <T>(type, endpoint, abortController, postData, options?: object, returnResponse?: boolean): Promise<T> => {
        return new Promise((resolve, reject) => {
            if (!Auth.current()) reject(false);
            const token = localStorage.getItem('auth.token');

            if (returnResponse !== true) returnResponse = false;

            const localOptions = {
                signal: abortController.signal,
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            const mergedOptions: any = { ...localOptions, ...options };
            mergedOptions.headers.Authorization = `Bearer ${token}`;

            let request;
            const url = getEndpoint(endpoint, {}, true);

            if (type === 'get') {
                request = axios.get(url, mergedOptions);
            } else {
                request = axios.post(url, postData, mergedOptions);
            }

            request
                .then(response => {
                    if (response.status === 200) {
                        if (returnResponse) {
                            resolve(response);
                        } else {
                            resolve(response.data);
                        }
                    } else {
                        reject(false);
                    }
                })
                .catch(error => {
                    reject([error]);
                });
        });
    };
}
